












































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import { Order } from '@/models/order';

@Component
export default class CustomerInfo extends Vue {
    @Prop({ default: () => new Order() })
    private order!: Order;

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse || [];
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore || [];
    }

    get selectedChinaStoreName() {
        if (!this.order) { return 'Kho Trung Quốc'; }
        const found = this.chinaStore.find((s: any) => s.ID === this.order.chinaStoreID);
        return found ? found.Name : (this.chinaStore[0] ? this.chinaStore[0].Name : 'Kho Trung Quốc');
    }

    get selectedWarehouseName() {
        if (!this.order) { return 'Kho nhận Việt Nam'; }
        const found = this.warehouse.find((w: any) => w.ID === this.order.receivePlaceID);
        return found ? found.Name : (this.warehouse[0] ? this.warehouse[0].Name : 'Kho Hà Nội / HCM');
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async created() {
        if (!this.warehouse || this.warehouse.length === 0) {
            await this.getWarehouse();
        }
        if (!this.chinaStore || this.chinaStore.length === 0) {
            await this.getChinaStore();
        }
    }
}
